export const EDIT_DISCOUNT_CODE_API = "payments/exly/discount/update";
export const GET_DISCOUNT_DETAILS = "payments/exly/discounts/details";
